import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { GlobalConstantsChart, GlobalConstantsDom, GlobalFunctions } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { ErgebnisGebaeude } from 'src/app/data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsDom } from 'src/app/immutable/constants-dom';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-chart-inv-bed-nd',
  templateUrl: './chart-inv-bed-nd.component.html',
  styleUrls: ['./chart-inv-bed-nd.component.css'],
})
export class ChartInvBedNdComponent implements OnInit {
  private guid: string = Guid.create().toString();
  private ergebnisseSubscription!: Subscription;
  private chartInstance!: Chart; 
  private isUpdated = false;

  constructor(public localService: LocalService) {}

  ngOnInit(): void {
    this.ergebnisseSubscription = this.localService.diagramErgebnisse.subscribe(
      (ergebnisse) => {
        if (ergebnisse) {
          this.createChart(ergebnisse.ergebnisGebaeudeList!);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.ergebnisseSubscription) {
      this.ergebnisseSubscription.unsubscribe();
    }
  }
 
  ngAfterViewChecked(): void {
    if (!this.isUpdated) {
      const element = document.getElementById(ConstantsDom.DOM_CHART_INV_BED_ND);
      if (element) { 
        element.setAttribute(GlobalConstantsDom.DOM_ID, this.guid);
        this.isUpdated = true;
      }
    }
  }

  async createChart(ergebnisGebaeudeList: ErgebnisGebaeude[]) {
    await new Promise((f) => setTimeout(f, 1)); // M 

    let dataLang: number[] = [];
    let dataMittel: number[] = [];
    let dataKurz: number[] = [];

    let temp : ErgebnisGebaeude[] = 
    ergebnisGebaeudeList.length > 1 
        ? ergebnisGebaeudeList.slice(1) 
        : ergebnisGebaeudeList.slice(0, 1);
    
        temp.forEach((entry) => {
      dataLang.push(entry.ergebnisInvBeNd.lang);
      dataMittel.push(entry.ergebnisInvBeNd.mittel);
      dataKurz.push(entry.ergebnisInvBeNd.kurz);
    });

    let chartDataSets: any[] = [];

    chartDataSets.push({
      label: ConstantsTexte.LANG_30,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[0],
      data: dataLang,
    });
    chartDataSets.push({
      label: ConstantsTexte.MITTEL_15,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[1],
      data: dataMittel,
    });
    chartDataSets.push({
      label: ConstantsTexte.KURZ_10,
      backgroundColor: GlobalConstantsChart.STACKED_BAR_VERGLEICHSFARBEN[2],
      data: dataKurz,
    });

    let titleText: string = ConstantsTexte.INVESTITIONSBEDARF_NUTZUNGSDAUER;
    let seitenUeberschriftText: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO

    if (this.chartInstance) { 
      this.chartInstance.destroy();
    }

    this.chartInstance = GlobalFunctions.getDiagramm(this.guid, Functions.getChartLabels(temp, this.localService.istGebaeude.value), chartDataSets, titleText, seitenUeberschriftText , 0, true, GlobalConstantsChart.FARBE_WEISS); 
  }
}
